function removeNotification(el: HTMLDivElement) {
    el.addEventListener('animationend', () => {
        el.remove();
    });
    el.style.height = el.scrollHeight + 'px';
    el.classList.add('notification-banner--removing');
}

window.Drupal.behaviors['notificationBanner'] = {
    attach(context: Document | HTMLElement, settings: DrupalSettings) {
        document.querySelectorAll<HTMLDivElement>('[data-notification-banner]').forEach((el) => {
            delete el.dataset['notificationBanner'];
            const closeBtn = el.querySelector<HTMLButtonElement>('[data-notification-banner-close]');
            if (closeBtn) {
                closeBtn.addEventListener('click', () => {
                    removeNotification(el);
                });
            }
        });
    },
};
